<template>
  <basic-container>
    <div class="contactContainer">
      <div class="banner_w3lspvt-2">
					<ol class="breadcrumb">
						<li class="breadcrumb-item" aria-current="page">{{ $t('aboutUs.title') }}</li>
					</ol>
				</div>
      <!-- contact -->
      <div class="contact py-5" id="contact">
        <div class="container pb-xl-5 pb-lg-3">
          <div class="row">
            <div class="col-lg-6">
              <img
                src="@/assets/images/jiannu.jpg"
                alt="image"
                class="img-fluid_contact"
              />
              <div class="contact_info">
                {{ $t('aboutUs.contact_info1') }}<br />
                {{ $t('aboutUs.contact_info2') }}<br />
                {{ $t('aboutUs.contact_info3') }}<br />
                {{ $t('aboutUs.contact_info4') }}<br />
                {{ $t('aboutUs.contact_info5') }}<br />
                {{ $t('aboutUs.contact_info6') }}
              </div>
              <div></div>
              <div class="social-icons-footer mb-md-0 mb-3">
                <ul class="list-unstyled">
                  <li>
                    <a href="mailto:contact@journal.ac.cn">
                      <span class="fa fa-envelope"></span
                      >contact@journal.ac.cn</a
                    >
                  </li>
                </ul>
                <ul class="list-unstyled">
                  <li>
                    <a href="#">
                      <span class="fa fa-phone"></span>13607673379</a
                    >
                  </li>
                </ul>
                <ul class="list-unstyled">
                  <li>
                    <a href="#">
                      <span class="fa fa-wechat"></span>19949128491</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-6 mt-lg-0 mt-5">
              <!-- contact form grid -->
              <div class="contact-top1">
                <div style="margin-top: 20px">
                  <div style="margin: 0 auto"></div>
                  <div style="">
                    <p>
                     {{ $t('aboutUs.reply') }}
                    </p>
                  </div>
                  <el-form
                    :model="ruleForm"
                    label-position="top"
                    size="large"
                    :rules="rules"
                    ref="ruleForm"
                  >
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item :label="$t('formAbout.name')" required prop="fieldA">
                          <el-input
                            v-model="ruleForm.fieldA"
                            autocomplete="off"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item :label="$t('formAbout.phone')" required prop="fieldB">
                          <el-input
                            v-model.number="ruleForm.fieldB"
                            autocomplete="off"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item :label="$t('formAbout.email')" required prop="fieldC">
                      <el-input v-model="ruleForm.fieldC" :rows="5" />
                    </el-form-item>
                    <el-form-item :label="$t('formAbout.message')" required prop="fieldD">
                      <el-input
                        v-model="ruleForm.fieldD"
                        type="textarea"
                        :rows="5"
                      />
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        plain
                        @click="submitForm('ruleForm')"
                        style="
                          font-size: 18px;
                          height: 50px;
                          width: 150px;
                          background-color: black;
                          color: white;
                        "
                      >
                        {{ $t('formAbout.submit') }}
                      </el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <!-- //contact form grid ends here -->
            </div>
          </div>
        </div>
      </div>
      <!-- //contact-->
    </div>
  </basic-container>
</template>

<script>
import { postForm } from "@/api/contactUs/contact";
export default {
  name: "index",
  data() {
    return {
      ruleForm: {
        fieldA: "",
        fieldB: "",
        fieldC: "",
        fieldD: "",
        classification: "jiannuContact",
      },
      rules: {
        fieldA: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: this.$t('formRules.name'),
          },
        ],
        fieldB: [
          {
            required: true,
            trigger: ["blur", "change"],
            message: this.$t('formRules.phone'),
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: this.$t('formRules.phoneFormat'),
            trigger: ["blur", "change"],
          },
        ],
        fieldC: [
          {
            required: true,
            message: this.$t('formRules.email'),
            trigger: ["blur", "change"],
          },
          {
            type: "email",
            message: this.$t('formRules.emailFormat'),
            trigger: ["blur", "change"],
          },
        ],
        fieldD: [
          {
            required: true,
            message: this.$t('formRules.message'),
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postForm(this.ruleForm)
            .then((response) => {
              if (response.code === 200) {
                this.$message({
                  type: "success",
                  message: this.$t('messagePrompt.success'),
                });
                this.resetForm(formName);
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('messagePrompt.fail'),
                });
              }
            })
            .catch((error) => {
              console.error('Error submitting form:', error);
              this.$message({
                type: "error",
                message: this.$t('messagePrompt.error'),
              });
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
};
</script>

<style lang="scss" scoped></style>
